<div id="mobile-app-info" class="modal modal-lg fade" role="dialog" tabindex="-1" aria-modal="true" aria-hidden="true" aria-labelledby="mobileAppInfoLabel">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title h4 w-100 text-center" id="mobileAppInfoLabel" translate>MOBILE_APP_PROMO.INFO_MODAL.TITLE</h2>
          <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-center">
              <div class="">
                <span class="infoHeader" translate>MOBILE_APP_PROMO.INFO_MODAL.HEADER</span>
                <p>
                <ul>
                    <li>{{'MOBILE_APP_PROMO.INFO_MODAL.BENEFITS.LINE1' | translate }}</li>
                    <li>{{'MOBILE_APP_PROMO.INFO_MODAL.BENEFITS.LINE2' | translate }}</li>
                    <li>{{'MOBILE_APP_PROMO.INFO_MODAL.BENEFITS.LINE3' | translate }}</li>
                </ul>
                <br>
                <br>
                <span class="scanInstructions">{{ 'MOBILE_APP_PROMO.INFO_MODAL.SCAN_INSTRUCTIONS' | translate }}</span>
              </div>
              <div class="d-flex flex-column ps-2 gap-1">
                <span style="text-align: center;">{{ 'MOBILE_APP_PROMO.INFO_MODAL.SCAN_ME' | translate  }}</span>  
                @if (serveProd) {
                  <img class="qr" src="assets/images/qr/QR_Code_TT_Mobile_App_Prod.png" alt="QR code to get TT Mobile App">
                } @else {
                  <img class="qr" src="assets/images/qr/QR_Code_TT_Mobile_App_Test.png" alt="QR code to get TT Mobile App">
                }
                
                <span style="text-align: center;">{{'GENERAL_REUSABLE.OR' | translate}}</span>

                <a href="https://apps.apple.com/us/app/trusted-traveler-programs/id6761013741" target="_blank" rel="noopener noreferrer" class="app-store-link apple">
                  <img [src]="getAppStoreBadgeSrc()" alt="{{'MOBILE_APP_PROMO.GET_ON_APP_STORE' | translate}}">
                </a>
                <a href="https://play.google.com/store/apps/details?id=gov.dhs.cbp.pspd.ttmobile&utm_source=na_Med" target="_blank" rel="noopener noreferrer" class="app-store-link google">
                    <img [src]="getGooglePlayBadgeSrc()" alt="{{'MOBILE_APP_PROMO.GET_ON_GOOGLE_PLAY' | translate}}">
                </a>

            </div>
          </div>

        </div>
        <div class="modal-footer justify-content-center">
              <div class="col-12 col-lg-4">
              <button type="button" class="btn d-block w-100 btn-primary" data-bs-dismiss="modal" translate>MODAL.BUTTON_CLOSE</button>
            </div>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
  
  